module.exports = __webpack_public_path__ + "img/Zeen-Currency.c3557015.svg";